import Controller from "csi/action/Controller";
import declare from "dojo/_base/declare";

const EnableColorwayToggleController = declare(Controller, {
	/**
    * @override
    * uncheck the toggle button after close the popup
    */
	onCancelReactDialog(): void {
		this["actionWidget"].set("checked", false, false);
		this.inherited(arguments);
	},
});

export = EnableColorwayToggleController;